import { Controller } from 'react-hook-form';
import Input from '@/components/input';

function InputController({
  type,
  className,
  inputName,
  inputId,
  control,
  label,
  info,
  rules,
  mask,
}) {
  return (
    <Controller
      name={inputId}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        formState: { errors },
      }) => (
        <Input
          mask={mask}
          type={type}
          className={className}
          id={inputId}
          name={inputName}
          label={label}
          value={value}
          error={errors?.[inputId]?.message || ''}
          onChange={(event) => {
            onChange(event);
          }}
          onBlur={onBlur}
          info={info}
        />
      )}
    />
  );
}
export default InputController;
